import React, { useState, useEffect } from 'react';
import ApiClient from '../../methods/api/apiClient';
import loader from '../../methods/loader';
import './style.scss';
import { useParams } from 'react-router-dom';
import Layout from '../../components/global/layout';
import { toast } from 'react-toastify';
import 'react-quill/dist/quill.snow.css';
import ImageUpload from '../../components/common/ImageUpload';
import { Dialog } from '@headlessui/react';
import methodModel from '../../methods/methods';
import { MdDelete } from "react-icons/md";



const AddEditInsightsCoaches = () => {
    const [submitted, setsubmitted] = useState(false)
    const { id } = useParams()
    const [Open, setOpen] = useState(false)
    const [form, setForm] = useState({
        type: "insights_from_coaches",
        main_heading: "",
        backgroud_image: "",
        data: [
            {
                boldTitle: "",
                title: "",
                description: "",
                image: "",
                is_archive: false,
                parts: [
                    {
                        number: "",
                        heading: "",
                        paragraph: ""
                    }
                ]
            }
        ]
    });

    console.log(form, "data")

    const handleInputChange = (e, index, partIndex = null) => {
        const { name, value } = e.target;
        if (partIndex !== null) {
            setForm(prevForm => {
                const updatedData = [...prevForm.data];
                updatedData[index].parts[partIndex][name] = value;
                return { ...prevForm, data: updatedData };
            });
        } else {
            setForm(prevForm => {
                const updatedData = [...prevForm.data];
                updatedData[index][name] = value;
                return { ...prevForm, data: updatedData };
            });
        }
    };

    const handleCheckbox = (e, index) => {
        const { checked } = e.target;

        setForm(prevForm => {
            const updatedData = [...prevForm.data];
            updatedData[index].is_archive = checked;
            return { ...prevForm, data: updatedData };
        });
    };

    const handleAddPart = (index) => {
        setForm(prevForm => {
            const updatedData = [...prevForm.data];
            updatedData[index].parts.push({ heading: "", paragraph: "" });
            return { ...prevForm, data: updatedData };
        });
    };

    const handleRemovePart = (index, partIndex) => {
        setForm(prevForm => {
            const updatedData = [...prevForm.data];
            updatedData[index].parts.splice(partIndex, 1);
            return { ...prevForm, data: updatedData };
        });
    };

    const handleAddData = () => {
        setForm(prevForm => ({
            ...prevForm,
            data: [
                ...prevForm.data,
                {
                    title: "",
                    description: "",
                    image: "",
                    is_archive: "",
                    parts: [{ number: "", heading: "", paragraph: "" }]
                }
            ]
        }));
    };

    const handleRemoveData = (index) => {
        setForm(prevForm => {
            const updatedData = [...prevForm.data];
            updatedData.splice(index, 1);
            return { ...prevForm, data: updatedData };
        });
    };


    const imageResult = (e, name, index) => {
        // const ALlParts = form?.data;
        // ALlParts[index]= e?.value
        // setForm(prevForm => ({
        //     ...prevForm,
        //     parts: ALlParts
        // }));
        setForm(prevForm => {
            const updatedData = [...prevForm.data];
            updatedData[index][name] = e.value;
            return { ...prevForm, data: updatedData };
        });
    };


    const handleSubmit = (e) => {
        e.preventDefault();
        setsubmitted(true);
        if (!form?.backgroud_image || form?.data.some((itm) => !itm?.image)) {
            return
        }
        let method = 'put';
        let url = 'page';
        let value = {
            ...form,
        };
        if (id) {
            method = 'put';
            url = 'page';
            value.id = JSON.parse(id);
        } else {
            delete value.id;
        }
        console.log(value, "value")

        // return
        loader(true);
        ApiClient.allApi(url, value, method).then((res) => {
            if (res.success) {
                setOpen(false)
                GetAllData()
                toast.success(res?.message);
            }
            loader(false);
        });
    };

    const GetAllData = () => {
        loader(true)
        ApiClient.get(`page?type=insights_from_coaches`).then((res) => {
            if (res.success) {
                console.log(res?.data, "data")
                const newData = res?.data
                setForm({
                    ...form,
                    main_heading: newData?.main_heading,
                    backgroud_image: newData?.backgroud_image,
                    data: newData?.data
                })
                loader(false)
            }
        })
    }

    useEffect(() => {
        GetAllData()
    }, [])



    return (
        <>
            <Layout>
                <form onSubmit={handleSubmit}>
                    <div className="pprofile1 shadow-lg">
                        <div className="flex items-center mb-8">
                            <div>
                                <h3 className="text-2xl font-semibold text-[#111827]">
                                    Insights From Coaches
                                </h3>
                            </div>
                        </div>

                        <div className="grid grid-cols-12 gap-4">
                            <>

                                <div className="col-span-12 md:col-span-6">
                                    <label>
                                        Main Heading<span className="star">*</span>
                                    </label>
                                    <input
                                        type="text"
                                        className="relative shadow-box bg-white w-full rounded-lg h-10 flex items-center gap-2 overflow-hidden focus-visible:outline-0 px-2"
                                        value={form?.main_heading}

                                        onChange={e => setForm({ ...form, main_heading: e.target.value })}
                                        required
                                    />
                                </div>

                                <div className="col-span-12 md:col-span-12 mb-3">
                                    <label className="lablefontcls">
                                        Main Image<span className="star">*</span>
                                    </label>
                                    <br></br>
                                    <ImageUpload
                                        model="users"
                                        result={(e) => { setForm({ ...form, backgroud_image: e.value }); console.log(e.value, "444") }}
                                        value={form?.backgroud_image}
                                    />
                                    {submitted && !form?.backgroud_image ? (
                                        <div className="invalid-feedback d-block">
                                            Image is required
                                        </div>
                                    ) : (
                                        <></>
                                    )}
                                </div>
                            </>
                        </div>

                        <div className='grid grid-cols-12 gap-4 '>
                            {form.data.map((item, index) => (<div className='col-span-12 shadow-md border-[1px] rounded-md px-5'>
                                <div className='grid grid-cols-12 gap-4 '>
                                    <div className="col-span-12 md:col-span-12 mt-5 flex gap-2 items-center justify-between bg-[#f1f1f1] p-3 w-full rounded-md">
                                        <div className='flex items-center justify-between gap-2 w-full'>
                                            <h2 className="text-[24px] text-[#A12238] font-[600] text-left">Part {index + 1}</h2>
                                            <div className='flex items-center gap-1'>
                                                <input value={item?.is_archive} checked={item?.is_archive} onChange={(e) => handleCheckbox(e, index)} type='checkbox' className='w-[20px] h-[20px] !mr-0' />
                                                <span>Archive</span>
                                            </div>
                                        </div>
                                        {index < 1 ? null : <button
                                            type="button"
                                            // onClick={() =>handleRemovePart(index, partIndex)}
                                            onClick={() => handleRemoveData(index)}
                                            className="text-red-600 hover:text-red-800 border border-[1px] bg-white rounded-full p-1 flex justify-end ml-auto"
                                        >
                                            <MdDelete className='text-[18px]' />
                                        </button>}
                                    </div>
                                    <div className="col-span-12 md:col-span-6">
                                        <label>
                                            Bold Title<span className="star">*</span>
                                        </label>
                                        <input
                                            type="text"
                                            name='boldTitle'
                                            className="relative shadow-box bg-white w-full rounded-lg h-10 px-2"
                                            value={item.boldTitle}
                                            onChange={(e) => handleInputChange(e, index)}
                                            required
                                        />
                                    </div>
                                    <div className="col-span-12 md:col-span-6">
                                        <label>
                                            Title<span className="star">*</span>
                                        </label>
                                        <input
                                            type="text"
                                            name='title'
                                            className="relative shadow-box bg-white w-full rounded-lg h-10 px-2"
                                            value={item.title}
                                            onChange={(e) => handleInputChange(e, index)}
                                            required
                                        />
                                    </div>

                                    <div className="col-span-12 md:col-span-12 mb-3">
                                        <label className="lablefontcls">
                                            Image<span className="star">*</span>
                                        </label>
                                        <br></br>
                                        <ImageUpload
                                            model="users"
                                            result={(e) => imageResult(e, "image", index)}
                                            value={item.image}
                                        />
                                        {submitted && !item?.image.length ? (
                                            <div className="invalid-feedback d-block">
                                                Image is required
                                            </div>
                                        ) : (
                                            <></>
                                        )}
                                    </div>

                                    <div className="col-span-12 md:col-span-12 mb-3">
                                        <label>
                                            Description<span className="star">*</span>
                                        </label>
                                        <textarea
                                            name='description'
                                            className="relative shadow-box bg-white w-full rounded-lg flex items-center gap-2 overflow-hidden focus-visible:outline-0 px-2 mt-1"
                                            value={item.description}
                                            onChange={(e) => handleInputChange(e, index)}
                                            rows="4"
                                            required
                                        />
                                    </div>
                                </div>

                                {item.parts.map((part, partIndex) => (<div className='p-5 bg-[#f1f1f1] rounded-md mt-5'>

                                    <div className="col-span-12 md:col-span-12 mb-3">
                                        <label>
                                            Number
                                        </label>
                                        <input
                                            type='number'
                                            name='number'
                                            className="relative shadow-box bg-white w-full rounded-lg h-10 flex items-center gap-2 overflow-hidden focus-visible:outline-0 px-2"
                                            value={part.number}
                                            onWheel={(e) => e.currentTarget.blur()}
                                            onChange={(e) => handleInputChange(e, index, partIndex)}
                                            rows="2"
                                        // required
                                        />
                                    </div>
                                    <div className="col-span-12 md:col-span-12 mb-3">
                                        <label>
                                            Heading
                                        </label>
                                        <input

                                            name='heading'
                                            className="relative shadow-box bg-white w-full rounded-lg h-10 flex items-center gap-2 overflow-hidden focus-visible:outline-0 px-2"
                                            value={part.heading}
                                            onChange={(e) => handleInputChange(e, index, partIndex)}
                                            rows="2"
                                        // required
                                        />
                                    </div>

                                    <div className="col-span-12 md:col-span-12 mb-3">
                                        <label>
                                            Paragraph<span className="star">*</span>
                                        </label>
                                        <textarea

                                            name='paragraph'
                                            className="relative shadow-box bg-white w-full rounded-lg flex items-center gap-2 overflow-hidden focus-visible:outline-0 px-2 mt-1"
                                            value={part.paragraph}
                                            onChange={(e) => handleInputChange(e, index, partIndex)}
                                            rows="4"
                                            required
                                        />
                                    </div>
                                    {partIndex > 0 && (
                                        <button
                                            type="button"
                                            // onClick={() => handleRemoveData(index)}
                                            onClick={() => handleRemovePart(index, partIndex)}
                                            className="text-red-600 hover:text-red-800 border border-[1px] bg-white rounded-full p-1 flex justify-end ml-auto"
                                        >
                                            <MdDelete className='text-[18px]' />
                                        </button>
                                    )}
                                </div>
                                ))}
                                <div className='col-span-12 md:col-span-12 mb-3 mt-3'>
                                    <button
                                        onClick={() => handleAddPart(index)}
                                        type="button"
                                        className="inline-block cursor-pointer text-white bg-[#A12238] focus:ring-4 focus:outline-none focus:ring-blue-300 dark:focus:ring-blue-800 font-medium rounded-lg text-sm px-5 py-2.5 text-center mb-2 "
                                    >
                                        Add More
                                    </button>
                                </div>

                            </div>))}
                        </div>
                        <div className="col-span-12 flex justify-end mt-5 md:col-span-12">
                            <button
                                onClick={handleAddData}
                                type='button'
                                className="inline-block cursor-pointer text-white bg-[#A12238] focus:ring-4 focus:outline-none focus:ring-blue-300 dark:focus:ring-blue-800 font-medium rounded-lg text-sm px-5 py-2.5 text-center mb-2 "

                            >Add More Part</button>

                        </div>

                        <div className="flex justify-end gap-3 mt-5">

                            <button
                                onClick={e => setOpen(true)}
                                type="button"
                                className="inline-block cursor-pointer text-white bg-[#A12238] focus:ring-4 focus:outline-none focus:ring-blue-300 dark:focus:ring-blue-800 font-medium rounded-lg text-sm px-5 py-2.5 text-center mb-2 "
                            >
                                Preview
                            </button>
                            <button
                                type="submit"
                                className="inline-block cursor-pointer text-white bg-[#A12238] focus:ring-4 focus:outline-none focus:ring-blue-300 dark:focus:ring-blue-800 font-medium rounded-lg text-sm px-5 py-2.5 text-center mb-2 "
                            >
                                Save
                            </button>
                        </div>
                    </div>
                </form>
            </Layout >

            <Dialog open={Open} onClose={() => setOpen(false)}>
                <Dialog.Backdrop
                    transition
                    className="fixed inset-0  transition-opacity data-[closed]:opacity-0 data-[enter]:duration-300 data-[leave]:duration-200 data-[enter]:ease-out data-[leave]:ease-in"/>
                <div className="fixed inset-0 z-10 w-screen overflow-y-auto bg-[#00000082]">
                    <div className="flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0">
                        <Dialog.Panel
                            className="relative transform overflow-hidden rounded-lg bg-white text-left shadow-xl transition-all data-[closed]:translate-y-4 data-[closed]:opacity-0 data-[enter]:duration-300 data-[leave]:duration-200 data-[enter]:ease-out data-[leave]:ease-in sm:my-8 sm:w-full sm:max-w-[800px] data-[closed]:sm:translate-y-0 data-[closed]:sm:scale-95"
                        >
                            <div className="bg-white px-4 pb-4 pt-3 ">
                                <div className="">

                                    <div className="mt-3 text-center sm:mt-0 sm:text-left">
                                        <h3 className="text-base font-semibold leading-6 text-gray-900 pb-2 mb-3 border-b-[1px] text-left">
                                            Preview
                                        </h3>
                                        <div className='body_section h-[calc(100vh_-_200px)] overflow-auto'>
                                            <div className="main_section pb-[2rem]">
                                                <div
                                                    className="flex justify-center items-center bg-no-repeat max-[499px]:h-[250px] max-[639px]:h-[300px] sm:h-[400px] pl-[50px] bg-cover max-[639px]:px-[15px] sm:px-[50px]"
                                                    style={{ backgroundImage: `url(${methodModel.pageImg(form?.backgroud_image)})`, filter: 'grayscale(1)' }}>
                                                    <div>
                                                        <h2 className="text-[#fff] max-[499px]:text-[22px] max-[639px]:leading-[25px] max-[639px]:text-[28px] sm:text-[38px] text-center leading-[45px]">{methodModel?.capitalizeFirstLetter(form?.main_heading)}</h2>
                                                        <p className="w-[50px] sm:w-[80px] h-[2px] bg-[#FFFFFF] mx-auto mt-4 mb-4"></p>
                                                    </div>
                                                </div>
                                                <div className="rectangle">
                                                    <img src="/assets/img/Rectangle.png"></img>
                                                </div>
                                                <div className='flex justify-end'>



                                                </div>
                                                {form?.data?.map((itm, indexo) => <div className='section max-[499px]:px-[15px] max-[639px]:px-[25px] sm:px-[50px] mt-[3rem]'>
                                                    <div className='container mx-auto'>
                                                        <div className='grid grid-cols-12 gap-[1rem] sm:gap-[2rem] items-center'>
                                                            {indexo % 2 === 0 ? <> <div className='col-span-12'>
                                                                <img src={methodModel.pageImg(itm?.image)} className='w-full h-[280px] sm:h-[420px] object-cover rounded-[50px]'></img>
                                                            </div> <div className='col-span-12'>
                                                                    <h3 className='max-[499px]:text-[22px] max-[639px]:text-[28px] text-[38px] text-[#252525] max-[499px]:leading-[35px] max-[639px]:leading-[40px] sm:leading-[50px] text-left'><span className='text-[#A12238] font-[600] text-left'>{methodModel?.capitalizeFirstLetter(itm?.boldTitle)}</span>{methodModel?.capitalizeFirstLetter(itm?.title)}</h3>
                                                                    <p className='text-[#252525] text-[15px] sm:text-[18px] max-[639px]:mt-[1rem] sm:mt-[2rem] font-[300] max-[499px]:leading-[30px] sm:leading-[35px] text-left'>{methodModel?.capitalizeFirstLetter(itm?.description)}</p>
                                                                </div></> : <><div className='col-span-12'>
                                                                    <h3 className='max-[499px]:text-[22px] max-[639px]:text-[28px] text-[38px] text-[#252525] max-[499px]:leading-[35px] max-[639px]:leading-[40px] sm:leading-[50px] text-left'><span className='text-[#A12238] font-[600] text-left'>{methodModel?.capitalizeFirstLetter(itm?.boldTitle)}</span>{methodModel?.capitalizeFirstLetter(itm?.title)}</h3>
                                                                    <p className='text-[#252525] text-[15px] sm:text-[18px] 2xl:text-[22px] max-[639px]:mt-[1rem] sm:mt-[2rem] font-[300] max-[499px]:leading-[30px] sm:leading-[35px] text-left'>{methodModel?.capitalizeFirstLetter(itm?.description)}</p>
                                                                </div>
                                                                <div className='col-span-12'>
                                                                    <img src={methodModel.pageImg(itm?.image)} className='w-full h-[280px] sm:h-[420px] object-cover rounded-[50px]'></img>
                                                                </div></>}
                                                        </div>


                                                        {itm?.parts?.map((item, index) => <div className='flex gap-5 '>

                                                            <div className='flex gap-5 max-[639px]:mt-[2rem] sm:mt-[4rem]'>
                                                                <div className='w-[45px] sm:w-[65px]'>
                                                                    {item?.number ? <span className='w-[40px] h-[40px] sm:w-[55px] sm:h-[55px] rounded-[50%] flex justify-center items-center text-[#fff] text-[18px] font-[600] bg-[#A12238] '>{item?.number}.</span> : <span className="w-[40px] h-[40px] sm:w-[55px] sm:h-[55px] lg:w-[75px] lg:h-[75px] rounded-[50%] flex justify-center items-center text-[#fff] text-[18px] lg:text-[24px] font-[600]" ></span>}
                                                                </div>
                                                                <div className=''>
                                                                    <h2 className='max-[639px]:text-[20px] sm:text-[24px] 2xl:text-[30px] text-[#252525] font-[600] text-left'>{methodModel?.capitalizeFirstLetter(item?.heading)}</h2>
                                                                    <p className='text-[15px] sm:text-[18px] text-[#252525] font-[300] leading-[30px] sm:leading-[35px] mt-2 text-left'>{methodModel?.capitalizeFirstLetter(item?.paragraph)}</p>
                                                                </div>
                                                            </div>
                                                        </div>)}
                                                        {form?.data?.length === indexo + 1 ? null : <div className='section max-[499px]:px-[15px] max-[639px]:px-[25px] sm:px-[50px] md:px-[50px]'>
                                                            <div className='container mx-auto'>
                                                                <div className='h-[1px] bg-[#A12238] my-[4rem]'></div>
                                                            </div>
                                                        </div>}

                                                    </div>
                                                </div>)}
                                                {form?.data?.length === 0 ? <h1 className='text-center max-[639px]:text-[20px] mt-5 sm:text-[24px] text-[#252525] font-[600] text-danger'>No Data</h1> : ""}


                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className='border-t-[1px]'>
                                <div className="px-4 py-3 flex justify-between sm:px-6 max-w-[400px] mx-auto">
                                    <button
                                        type="button"
                                        data-autofocus
                                        onClick={() => setOpen(false)}
                                        className="mt-3 inline-flex w-full justify-center rounded-md bg-[#efefef] px-8 py-2 text-sm font-semibold text-[#353535] shadow-sm !ring-0 border-[1px] !outline-0 hover:opacity-[80%] sm:mt-0 sm:w-auto"
                                    >
                                        Cancel
                                    </button>
                                    <button
                                        type="button"
                                        data-autofocus
                                        onClick={e => handleSubmit(e)}
                                        className="mt-3 inline-flex w-full justify-center rounded-md bg-[#A12238] px-8 py-2 text-sm font-semibold text-white shadow-sm !ring-0 !border-0 !outline-0 hover:opacity-[80%] sm:mt-0 sm:w-auto"
                                    >
                                        Save
                                    </button>
                                </div>
                            </div>
                        </Dialog.Panel>
                    </div>
                </div>
            </Dialog>
        </>
    );
};

export default AddEditInsightsCoaches;
